import GoogleReviewsSlider from "@/components/GoogleReviewsSlider";

// On the About page we just render the same Google reviews slider.
export default function Testimonials() {
  return <GoogleReviewsSlider />;
}
